export default "__VITE_ASSET__be0b7212__"